[
  {
    "revision": null,
    "url": "/offline"
  }
]